import { CreditCard } from 'lucide-react';
import { GuideCategory } from './types';

export const plansBillingGuide: GuideCategory = {
  id: 'plans-and-billing',
  title: 'Plans & Upgrades',
  icon: CreditCard,
  articles: [
    {
      slug: 'subscription-tiers',
      title: 'Choosing a Plan',
      description: 'Unlocking the full power of our professional ball engine features.',
      sections: [
        {
          id: 'free-tier',
          title: 'The Free Experience',
          content: 'The free tier gives you full access to the core ball bouncing simulator on browser. You can create, experiment, and record videos with standard quality settings.'
        },
        {
          id: 'pro-tier',
          title: 'Pro & Studio Features',
          content: 'Upgrading to Pro or Studio unlocks advanced features like high-definition cloud rendering, unlimited custom audio storage, and exclusive ball engine modes.'
        }
      ]
    }
  ]
};
